import { AKOA_SIGNED_EVENT, clearAkoa, getAkoaSignature, isAkoaCompleted, } from './akoa';
/**
 * Installs the theme-wide `window.akoa` API.
 *
 * Imported statically by `web_components/index.ts`, so it ships inside
 * `islands.js` rather than an async chunk. `islands.js` is a deferred script,
 * which means it runs before any dynamically imported chunk's callback — so the
 * Preact sections (legacy PDP, service form, Lifesharp, customizer), all of which
 * are lazy chunks, can read `window.akoa` synchronously during their first render
 * without importing anything.
 *
 * Only the state layer lives here. The flyout element (and Lit with it) stays in
 * the async `akoa` entry chunk, loaded by the island marker that the flyout
 * snippet renders alongside it — pages without the agreement never pay for it.
 */
const TAG_NAME = 'akoa-flyout';
async function resolveFlyout() {
    // No element means the page does not render the agreement at all — no wait.
    if (!document.querySelector(TAG_NAME))
        return null;
    // The element and its eager `akoa` island marker are rendered by the same
    // snippet, so a present element always has a definition on the way.
    await customElements.whenDefined(TAG_NAME);
    return document.querySelector(TAG_NAME);
}
/** Opens the agreement. Resolves true when signed, false when dismissed. */
async function open() {
    const flyout = await resolveFlyout();
    if (!flyout)
        return isAkoaCompleted();
    return flyout.open();
}
/** True when already signed; otherwise opens the agreement and returns false. */
function validate() {
    if (isAkoaCompleted())
        return true;
    open();
    return false;
}
window.akoa = {
    signedEvent: AKOA_SIGNED_EVENT,
    isCompleted: isAkoaCompleted,
    getSignature: getAkoaSignature,
    open,
    validate,
    clear: clearAkoa,
};
